import { createContext, ComponentType } from 'react';
import { PrintTaskRefs } from 'store/entity/IPrintTemplatePart';
import { IUser } from '../users/usersType';
import { ICompanyServer } from '../companies/companiesTypes';
import { ITask } from '../tasks/tasksType';
import { IProviderItemView } from '../providers/providerTypes';

export interface IPrintSingleTaskContext {
  members?: IUser[];
  company?: ICompanyServer;
  taskIds?: { [key in PrintTaskRefs]: number | undefined };
  allTasks?: ITask[];
  relatedProviderItems?: IProviderItemView[];
}

export const PrintSingleTaskContext = createContext<IPrintSingleTaskContext>(
  {}
);

export const PrintSingleTaskProvider = PrintSingleTaskContext.Provider;

export const PrintSingleTaskConsumer = PrintSingleTaskContext.Consumer;

export const withRelatedResponsesContext =
  (Component: ComponentType<any>) => (props: IPrintSingleTaskContext) => (
    <PrintSingleTaskConsumer>
      {(dataContext) => <Component {...props} dataContext={dataContext} />}
    </PrintSingleTaskConsumer>
  );
